module.exports = __webpack_public_path__ + "img/gal-02.671487f5.png";